import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useThemeValue } from '../../state/theme';
import { getFlexClasses } from '../../utils/getFlexClasses';
import { getFlexItemClasses } from '../../utils/getFlexItemClasses';
/**
 * Container for the app content - typically used next to a
 * HeaderBar to wrap the CurrentRoute and the resulting app content
 */
export const ContentContainer = (props) => {
    const { footer, children } = props;
    const bodyBackgroundClass = useThemeValue('body-background', 'bg-gray-300');
    const contentBackgroundClass = useThemeValue('content-background', 'bg-white');
    return (_jsxs("div", Object.assign({ className: clsx('pt-16 min-h-screen pb-1', getFlexClasses({ column: true }), bodyBackgroundClass) }, { children: [_jsx("div", Object.assign({ className: clsx('shadow-md xl:m-4 xl:flex-row', contentBackgroundClass, getFlexItemClasses({ grow: true }), getFlexClasses({})) }, { children: children }), void 0),
            footer] }), void 0));
};
//# sourceMappingURL=ContentContainer.js.map